import { Component, OnInit,ViewEncapsulation ,Inject} from '@angular/core';
import { Helper, AppDateAdapter, APP_DATE_FORMATS } from '../Helper';
import {MatBottomSheet, MatBottomSheetRef,MAT_BOTTOM_SHEET_DATA} from '@angular/material/bottom-sheet';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Router } from '@angular/router';
import {FormControl, FormGroup,Validators} from '@angular/forms';
import { CustomValidators } from '../CustomValidators';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material';
@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.css'],

  encapsulation: ViewEncapsulation.None
})
export class TabsComponent implements OnInit {
  animal;
  user:any={trainer_personal_detail:{}};
  loadNewUser=false;
  mindate;
  selectedTab=0;
  displayedColumns: string[] = ['position', 'name', 'institution_name', 'weight', 'symbol'];
  dataSource=[

  ];
  constructor(public Helper:Helper,
    private _bottomSheet: MatBottomSheet,
    public dialog: MatDialog,
    public router:Router
    ) {

      Helper.user.subscribe(data=>{
        if(!data.completeChange)
        {
          this.user.trainer_personal_detail.first_name= data.first_name;
          this.user.trainer_personal_detail.sur_name  = data.sur_name;
        }
      });


    }

  ngOnInit() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    this.mindate = mm + '/' + dd + '/' + yyyy;

    let token=this.Helper.get("token");

    if(token){
      this.Helper.makeRequest("auth/refresh",{},"get",{toast:false}).subscribe(data=>{

        this.Helper.set("token",data.access_token);
        this.Helper.me((data)=>{
          this.user=data;

          this.Helper.set("user",data);
          this.loadNewUser=true;
          this.selectedTab= data.trainer_personal_detail.step_completed+1;
          if(this.user.trainer_personal_detail.step_completed==6){
            this.router.navigate(["/assessors/dashboard"]);
          }

        })
        //
      },err=>{
        this.Helper.set("token",null);
        this.Helper.set("user",null);
        this.Helper.user.emit({completeChange:1});
        this.router.navigate(["/auth/login"]);

      })


    }
    else{
      this.router.navigate(["/auth/login"]);
    }

  }
  openBottomSheet(): void {

    this._bottomSheet.open(BottomSheetOverviewExampleSheet);
  }
  nextTab(tabval){
    let tab;
    let force=0;
    if(typeof tabval =="number"){
      tab=tabval
    }
    else{
      tab=tabval.tab;
      force=tabval.force;
    }
    this.selectedTab=tab;
      if( this.user.trainer_personal_detail.step_completed<tab || force)
      {
        this.user.trainer_personal_detail.step_completed=tab-1 ;
      }
  }
  tabChange(e){
    console.log(e,"tab")
    this.selectedTab=e.index;
    if(e.index==5){
      this.Helper.user.emit({completeChange:1})
    }
  }


  openDialog(): void {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {

      data: {name: "Aman", animal: "jain"}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.animal = result;
    });
  }

}

@Component({
  selector: 'bottom-sheet-overview-example-sheet',
  templateUrl: 'bottom-sheet.html',
  styleUrls: ['./bottom-sheet.component.css'],
  providers: [

]
})
export class BottomSheetOverviewExampleSheet {
  msg="Are you sure you want to delete this?"

  confirm="Confirm";

  constructor(private _bottomSheetRef: MatBottomSheetRef<BottomSheetOverviewExampleSheet>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data) {
      console.log(data)
      if(data && data.msg)
      this.msg=data.msg;

      if(data && data.confirm)
      this.confirm=data.confirm;
    }

  openLink(b): void {
    this._bottomSheetRef.dismiss(b);
    event.preventDefault();
  }
}


// @Component({
//   selector: 'center-sheet-overview-example-sheet',
//   templateUrl: 'bottom-sheet.html',
//   providers: [

// ]
// })
// export class CenterSheetOverviewExampleSheet {
//   msg="Are you sure you want to delete this?"
//   constructor( public dialogRef: MatDialogRef<CenterSheetOverviewExampleSheet>,public Helper:Helper,
//     @Inject(MAT_DIALOG_DATA) public data) {
//       console.log(data)
//       if(data && data.msg)
//       this.msg=data.msg;
//     }

//   openLink(b): void {
//     this.dialogRef.close();
//     event.preventDefault();
//   }
// }


@Component({
  selector: 'center-sheet-overview-example-sheet',
  templateUrl: 'bottom-sheet.html',
  providers: [

]
})
export class CenterSheetOverviewExampleSheet {
  msg="Are you sure you want to delete this?"
  confirm="Are you sure you want to delete this?"
  constructor( public dialogRef: MatDialogRef<CenterSheetOverviewExampleSheet>,public Helper:Helper,
    @Inject(MAT_DIALOG_DATA) public data) {
      console.log(data)
      if(data && data.msg)
      this.msg=data.msg;
    }

  openLink(b): void {
    this.dialogRef.close();
    event.preventDefault();
  }
}


@Component({
  selector: 'dialog-overview-example-dialog',
  templateUrl: 'popup.html',
  providers: [
  {provide: DateAdapter, useClass: AppDateAdapter},
    {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS}
  ]
})


export class DialogOverviewExampleDialog {
  maxDate=new Date();
  minDate;
  filename="";
  transcriptsfileName="";
  search:any={}
  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,public Helper:Helper,
    @Inject(MAT_DIALOG_DATA) public data
     ) {


     }

  onNoClick(): void {
    this.dialogRef.close();
  }

  form;
  mindate;
  loading=false;

  states   = [
  ];

  getErrorMessage(name) {
    return this.Helper.validationErrors(this.form.get(name));
  }


  specilizations=[];
  ngOnInit() {


    console.log(this.data)

    if(!this.data ){



      this.form = new FormGroup({
        id:  new FormControl('', []),
        qualification_id:  new FormControl("", [Validators.required]),
        institute_name:  new FormControl("", [Validators.required,CustomValidators.onlyChar()]),
        area_of_specialization:  new FormControl('', [Validators.required]),
        cluster_id:  new FormControl('', [Validators.required]),
        date_obtained:  new FormControl("", [Validators.required]),
        certificate:  new FormControl(null, [Validators.required]),
        transcripts: new FormControl(null, [Validators.required]),



      });
      // this.changeAos();
      // this.specilizations=JSON.parse(JSON.stringify(this.Helper.settings.dropdowns.area_of_specialization));

    }
      else{
        let exp=this.data;
        this.filename=exp.certificate_name;
        this.transcriptsfileName=exp.transcripts_name
        this.form = new FormGroup({
          id:  new FormControl(exp.id, []),
          qualification_id:  new FormControl(exp.qualification_id, [Validators.required]),
          institute_name:  new FormControl(exp.institute_name, [Validators.required]),
          area_of_specialization:  new FormControl(exp.area_of_specialization, [Validators.required]),
          cluster_id:  new FormControl(exp.cluster_id, [Validators.required]),

          date_obtained:  new FormControl(exp.date_obtained, [Validators.required]),
          certificate:  new FormControl(null, []),
          transcripts:  new FormControl(null, []),



        });
        let insertSpec=true
        // this.specilizations=JSON.parse(JSON.stringify(this.Helper.settings.dropdowns.area_of_specialization));
        this.changeAos();
        for(let aos of  this.specilizations){
          if(aos.title==exp.area_of_specialization)
          {
            insertSpec=false;

            break;
          }
        }

        if(insertSpec){
          this.specilizations.push({"title":exp.area_of_specialization});
        }
      }
      this.Helper.me((data)=>{
        var t = data.trainer_personal_detail.dob.split("-");
console.log(t);
      // Apply each element to the Date function
      this.minDate = new Date(Date.UTC(t[0], t[1]-1, t[2]));



      })

  }
  setFile(e){
    if ( e.target.files[0].size/1024/1024>20) {
      this.Helper.toast("File size should be less than 20MB","error")
      return;
    }
    this.form.controls['certificate'].setValue(e.target.files[0]);
    this.filename=e.target.files[0].name;
  }

  setTransFile(e){
    if ( e.target.files[0].size/1024/1024>20) {
      this.Helper.toast("File size should be less than 20MB","error")
      return;
    }
    this.form.controls['transcripts'].setValue(e.target.files[0]);
    this.transcriptsfileName=e.target.files[0].name;
  }
 changeAos(){
    this.specilizations=[];

     for(let ql of this.Helper.settings.dropdowns.area_of_specialization){
       console.log("amqualification_id",this.form.get('cluster_id').value, ql.id,ql)

      if(this.form.get('cluster_id').value==ql.cluster_id){



        this.specilizations.push(ql);
      }
    }


  }
  submit(){

    if(!this.form.valid ){
      return 1;
    }
    this.loading=true;

    if(this.form.value.date_obtained){
      this.form.value.date_obtained= this.Helper.convertToDate(this.form.value.date_obtained);

    }
    if(this.form.value.certificate instanceof Blob){

    }
    else{
      delete this.form.value.certificate;
    }

    this.Helper.makeRequest("assessor/trainer-qualification",this.form.value,"postupload").
    subscribe((data)=>{
      this.loading=false;

      this.dialogRef.close();

    },(err)=>{
      console.log(err.error);

      this.Helper.showServerErrors(err.error.errors,this.form);
      this.Helper.toast(err.error.message,"error")
      this.loading=false;

    });
  }

}



@Component({
  selector: 'education-popup',
  templateUrl: 'education-popup.html',
  providers: [


    {provide: DateAdapter, useClass: AppDateAdapter},
    {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS}
  ]
})
export class ExperiencePopup {
  maxStartDate=new Date();
  minStartDate=null;
  minEndDate=null;
  maxEndDate=new Date();
  filename="";
  type=""
  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data,public Helper:Helper
     ) {

      console.log(data,"ecp")
      this.type=data.type
     }

  onNoClick(): void {
    this.dialogRef.close();
  }

  form;
  mindate;
  loading=false;

  states   = [
  ];

  getErrorMessage(name) {
    return this.Helper.validationErrors(this.form.get(name));
  }
  validateDateEnd(){
    console.log(this.form.get('start_date').value);
    this.minEndDate=this.form.get('start_date').value;

  }
  validateDateStart(){
    console.log(this.form.get('end_date').value);
    this.maxStartDate=this.form.get('end_date').value;

  }

  ngOnInit() {

    if(!this.data.id ){



      this.form = new FormGroup({
        id:  new FormControl('', []),
        place_of_work:  new FormControl("", [Validators.required]),
        start_date:  new FormControl("", [Validators.required]),
        end_date:  new FormControl("", [Validators.required]),
        current_job:  new FormControl(false, []),
        position:  new FormControl(null, [Validators.required,CustomValidators.onlyChar()]),
        achievement:  new FormControl(null, [Validators.required]),
        testimonial:  new FormControl(null, [Validators.required]),

        type:new FormControl(this.data.type, [Validators.required]),


      });
    }
      else{
        let exp=this.data;

        this.form = new FormGroup({
          id:  new FormControl(exp.id, []),
          place_of_work:  new FormControl(exp.place_of_work, [Validators.required]),
          start_date:  new FormControl(exp.start_date, [Validators.required]),
          end_date:  new FormControl(exp.end_date, exp.current_job=='true'?[] :[Validators.required]),
          current_job:  new FormControl(exp.current_job=='true'?true:false, []),
          position:  new FormControl(exp.position, [Validators.required]),
          achievement:  new FormControl(exp.achievement, [Validators.required]),
          testimonial:  new FormControl(null, []),
          type:new FormControl(this.data.type, [Validators.required]),



        });
        this.filename=exp.testimonial_name;
      }
      this.Helper.me((data)=>{
        var t = data.trainer_personal_detail.dob.split("-");

      // Apply each element to the Date function
        this.minStartDate = new Date(Date.UTC(t[0], t[1]-1, t[2]));
        this.minEndDate = new Date(Date.UTC(t[0], t[1]-1, t[2]));


      })
  }
  setValidation(){
    console.log(this.form.controls['current_job'].value)
    if(this.form.controls['current_job'].value){

      this.form.controls['end_date'].clearValidators();
      this.form.controls['end_date'].updateValueAndValidity();
      this.form.controls['end_date'].setValue("");
      this.form.controls['end_date'].disable();

    }
    else{
      this.form.controls['end_date'].setValidators([Validators.required]);
      this.form.controls['end_date'].updateValueAndValidity();
      this.form.controls['end_date'].enable();
    }

  }
  setFile(e){
    var mimeType = e.target.files[0].type;
    // console.log(mimeType,"mimeType")
    // || mimeType.match(/image\/*/) == null ||
    // if (mimeType.match(/image\/*/) == null ) {
    //   this.Helper.toast("Please upload image file","error")
    //   return;
    // }

    if ( e.target.files[0].size/1024/1024>20) {
      this.Helper.toast("File size should be less than 20MB","error")
      return;
    }
    this.form.controls['testimonial'].setValue(e.target.files[0]);
    this.filename=e.target.files[0].name;
  }

  submit(){
    console.log(this.form.valid ,"form",this.form)
    if(!this.form.valid ){
      return 1;
    }
    this.loading=true;

    if(this.form.value.start_date){
      this.form.value.start_date= this.Helper.convertToDate(this.form.value.start_date);

    }
    if(this.form.value.end_date){
      this.form.value.end_date= this.Helper.convertToDate(this.form.value.end_date);

    }

    if(this.form.value.testimonial instanceof Blob){

    }
    else{
      delete this.form.value.testimonial;
    }
    this.Helper.makeRequest("assessor/trainer-work-experience",this.form.value,"postupload").
    subscribe((data)=>{
      this.loading=false;
      this.dialogRef.close();
    },(err)=>{
      console.log(err.error);

      this.Helper.showServerErrors(err.error.errors,this.form);
      this.Helper.toast(err.error.message,"error")
      this.loading=false;

    });
  }

}
